var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnlimitedMyroom = function SvgUnlimitedMyroom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5223",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "#FEDB41"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5223)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.0714,
    cy: 100.459,
    r: 17.398,
    fill: "#FFECE6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.6531,
    cy: 51.6327,
    r: 5.61224,
    fill: "#9EF2B1",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2345 83.7312C95.8914 83.7312 97.2345 85.0743 97.2345 86.7312V100.484C97.2345 102.335 95.7344 103.835 93.8839 103.835H85.5074C84.5822 103.835 83.8321 103.085 83.8321 102.159V97.1336C83.8321 95.2831 82.332 93.783 80.4815 93.783C78.6311 93.783 77.131 95.2831 77.131 97.1336V102.159C77.131 103.085 76.3809 103.835 75.4557 103.835H67.0792C65.2287 103.835 63.7286 102.335 63.7286 100.484V86.7312C63.7286 85.0743 65.0717 83.7312 66.7286 83.7312H94.2345Z",
    fill: "url(#paint0_linear_1112_5223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.255 81.7209L96.0615 77.7421L80.4812 68.9886L64.901 77.7421L59.7076 81.7209H101.255Z",
    fill: "url(#paint1_linear_1112_5223)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9759 65.8766C80.4913 65.5585 81.1413 65.5585 81.6566 65.8766L102.502 78.7428C103.256 79.2083 103.491 80.1989 103.027 80.9553C102.563 81.7118 101.575 81.9476 100.821 81.4821L80.8163 69.1347L60.8114 81.4821C60.0572 81.9476 59.0695 81.7118 58.6054 80.9553C58.1413 80.1989 58.3764 79.2083 59.1306 78.7428L79.9759 65.8766Z",
    fill: "url(#paint2_linear_1112_5223)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5935 69.2401C80.1367 68.9048 80.8261 68.9048 81.3693 69.2401L93.8838 76.9648V95.1648C93.8838 96.9923 92.3836 98.4739 90.5332 98.4739H88.8579C87.9326 98.4739 87.1826 97.7345 87.1826 96.8207V93.5102C87.1826 89.7875 83.4073 88.5466 80.4814 88.5466C77.5555 88.5466 73.7802 89.8551 73.7802 93.5102V96.8197C73.7802 97.7335 73.0302 98.4739 72.1049 98.4739H70.4296C68.5792 98.4739 67.079 96.9923 67.079 95.1648V76.9648L79.5935 69.2401Z",
    fill: "url(#paint3_linear_1112_5223)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5223",
    x1: 97.2345,
    y1: 83.7312,
    x2: 63.7286,
    y2: 83.7312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5223",
    x1: 101.255,
    y1: 68.9886,
    x2: 59.7076,
    y2: 68.9886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_5223",
    x1: 103.265,
    y1: 65.6381,
    x2: 58.3673,
    y2: 65.6381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1112_5223",
    x1: 80.4814,
    y1: 68.9883,
    x2: 80.4814,
    y2: 98.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnlimitedMyroom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unlimited-myroom.5c3e6d9fee2084def9801a859be9628a.svg";